import React from 'react'
import Chip from '@mui/material/Chip'

export function ComingSoon(): JSX.Element {
  return <Chip label="coming soon" color="primary" variant="outlined" />
}
